import type { FaireProductEntity } from "../../entity_types/product";

export const p_u9jtx4ts3a: FaireProductEntity = {
  token: "p_u9jtx4ts3a",
  type: "product",
  name: "16oz Calypso Strawberry Lemonade Fruit Flavored Glass Bottle",
  brandToken: "b_7b25cuen6n",
  brandName: "EcoQuality",
  imageUrl:
    "https://cdn.faire.com/fastly/4deb1e74c9e5dfb21ea6ec754cd0939a76b0436672179f03064d48b70b21ab93.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0eda6657188e4762b2810be33def91dda5fee80c9f4bf6c2536ee4620c23e38d.png",
    "https://cdn.faire.com/fastly/f6567843fbf47665b27bbf365e98fb3f7de09c5486512a607bfa8eb447924886.png",
  ],
  priceDollars: 52,
  description:
    "16oz Calypso Strawberry Lemonade Fruit Flavored Glass Bottled Beverage\n\nEnjoy the bold blend of sweet strawberry and tart lemon with Calypso Strawberry Lemonade in a refreshing 16oz clear glass bottle. This vibrant flavored lemonade delivers smooth fruit sweetness balanced with bright citrus notes, making it ideal for grab and go coolers, retail displays, parties, and catering service. The durable glass bottle enhances shelf appeal, preserves freshness, and offers a recyclable packaging solution for premium single serve beverage merchandising.\n\nFeatures:\n16oz single serve bottle for portion control\nMade with natural flavors\nVibrant pink color for fun presentation\nSweet strawberry and tart lemon flavor blend\nRefreshing and thirst-quenching\nGreat for parties, events, or daily enjoyment\nResealable cap for convenience\nClear glass bottle for premium presentation\nFull case includes 12 pieces",
  tags: [],
  msrpDollars: 65,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:14.403Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
